import { faqSections } from 'root/src/client/v2/_pages/faq/redesign/faqContent';
// FAQ table of contents, derived from the same verbatim `faqSections` array the body renders (so the
// labels and `id`s never drift, no retyping). Each section is a heading button; each question is a
// nested button. Clicks delegate to the page, which opens the target accordion item (for questions) and
// smooth-scrolls to the matching `AnchorTarget` (which lands the heading clear of the fixed navbar).
// Buttons inherit neon-cyan link styling from the surrounding ContentProse in the sidebar slot.
export const FaqTableOfContents = ({ onNavigate }) => (<nav className="space-y-5 text-sm">
		{faqSections.map(section => (<div key={section.id}>
				<button type="button" onClick={() => onNavigate(section.id, false)} className="font-display text-sm font-semibold text-foreground transition-colors hover:text-primary">
					{section.sectionTitle}
				</button>
				<ul className="mt-2 space-y-1.5 border-l border-solid border-border pl-3">
					{section.items.map(item => (<li key={item.id}>
							<button type="button" onClick={() => onNavigate(item.id, true)} className="text-left text-muted-foreground transition-colors hover:text-primary">
								{item.title}
							</button>
						</li>))}
				</ul>
			</div>))}
	</nav>);
